var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 5,
    fill: "white",
    stroke: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90418 7.99V6.94H6.08418V7.99H4.90418ZM4.99418 14V9.12H6.00418V14H4.99418Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRedIcon);
export default __webpack_public_path__ + "static/media/infoRedIcon.71483142b2622623b041dc2a24708b9d.svg";
export { ForwardRef as ReactComponent };